import React from 'react';
import { Link } from 'gatsby';
import { useSiteMetadata } from 'hooks/useSiteMetadata';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import './Menu.scss';

const Index = () => {
	const { title, description } = useSiteMetadata();

	return (
		<div className="menu">
			<Link to="/">
				<h1 id="site-name">{title}</h1>
				<p className="site-description">{description}</p>
			</Link>
			<div className="menu__items">

			</div>
		</div>
	);
};

export default Index;
